.manuellRegistrering {
  display: inline;
  margin-left: var(--dds-spacing-small-4);
}
